module.exports = window["ReactJSXRuntime"];